import { Element } from 'slate'
import type {
    ParagraphDescendant,
    MentionNode,
    UnitAttributeNode,
    NewLineNode,
    TextNode,
    RichTextParagraph,
} from './types.no-deps'
import { filter, flatten, map, uniqStable } from '../../lib/functional/array.no-deps'
import { compose } from '../../lib/functional/compose.no-deps'

export function isMentionNode(node: ParagraphDescendant): node is MentionNode {
    return Element.isElement(node) && node.type === 'mention'
}

export function isUnitAttributeNode(node: ParagraphDescendant): node is UnitAttributeNode {
    return Element.isElement(node) && node.type === 'unit-attribute'
}

export function isNewLineNode(node: ParagraphDescendant): node is NewLineNode {
    return Element.isElement(node) && node.type === 'new-line'
}

export function isTextNode(node: ParagraphDescendant): node is TextNode {
    return !Element.isElement(node)
}

export function isEmpty(paragraphs: RichTextParagraph[]) {
    return !paragraphs
        .map((paragraph) => paragraph.children)
        .flat()
        .some((descendant) => !isTextNode(descendant) || descendant.text)
}

export function removeNonTextNodes(paragraphs: RichTextParagraph[]) {
    return paragraphs.map((paragraph) => ({
        children: paragraph.children.filter(isTextNode),
    }))
}

/**
 * Returns a array of unique user IDs mentioned in a comment.
 */
export const getMentionedUserIds: (paragraphs: RichTextParagraph[]) => number[] = compose(
    map((richTextParagraph: RichTextParagraph) => richTextParagraph.children),
    flatten,
    filter(isMentionNode),
    map((item: MentionNode) => item.userId),
    uniqStable
)
